import { Col, Row } from "react-bootstrap";
import { useGetQuotationConsts } from "pages/common/ShipmentQuotesV2/helpers/ShipmentQuotesV2Helpers";
import { IQuotation } from "pages/shipper/ShipmentQuotes/components/quotes/QuotesType";
import QuotationCard from "../../QuotationCard/QuotationCard";

type QuotationDetailQuoteInfoProps = {
  quotations: IQuotation[];
  currentQuotation: IQuotation;
};

function QuotationDetailQuoteInfo(props: QuotationDetailQuoteInfoProps) {
  const { quotations, currentQuotation } = props;

  const { hasAtLeastOneRateCardQuote, quoteTags, trafficLightBuckets } = useGetQuotationConsts(quotations);

  return (
    <div className="px-3xl py-lg">
      <QuotationCard
        quotation={currentQuotation}
        hasAtLeastOneRateCardQuote={hasAtLeastOneRateCardQuote}
        quoteTags={quoteTags}
        trafficLightBuckets={trafficLightBuckets}
        quotationCount={quotations.length}
        hideFooter
      />
      <Row className="mt-lg">
        <Col md={6}>
          <div className="text-xs text-secondary-v2 font-medium">Quote submitted by</div>
          <div className="text-sm text-primary font-regular">{currentQuotation?.provider?.created_by || "-"}</div>
          <div className="text-xs text-tertiary font-regular">{currentQuotation?.provider?.team || "-"}</div>
        </Col>
        <Col md={6}>
          <div className="text-xs text-secondary-v2 font-medium">Contact info</div>
          {currentQuotation?.provider?.created_by_email && (
            <div className="text-sm text-brand-tertiary font-regular">
              <a
                href={`mailto:${currentQuotation.provider.created_by_email}`}
                className="text-brand-tertiary font-regular"
                style={{ textDecoration: "underline" }}
              >
                {currentQuotation.provider.created_by_email}
              </a>
            </div>
          )}
          {currentQuotation?.provider?.created_by_phone && (
            <div className="text-xs text-tertiary font-regular">{currentQuotation.provider.created_by_phone}</div>
          )}
        </Col>
      </Row>
    </div>
  );
}
export default QuotationDetailQuoteInfo;
